export function getIds(data) {
  let ids = "";
  data.map((item) => {
    ids = ids + item.id + ",";
  });
  return ids;
}

export function getRandomString() {
  return Math.random().toString(36).substring(2, 9);
}
